import { Box, Typography } from '@mui/material';
import TotalWinningsBanner from './TotalWinningsBanner';
import RapchikRewardCard from './RapchikRewardCard';

export default function RapchikRewardsPanel({
  data,
  loading = false,
  onRevealPrize,
  onInfoClick,
}) {
  const items = Array.isArray(data?.items) ? data.items : [];

  if (loading) {
    return null;
  }

  if (items.length === 0) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
        <Typography sx={{ color: '#e6d4ff', fontSize: 16, fontWeight: 600, textAlign: 'center' }}>
          No Rapchik rewards yet.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 2, md: 2.5 } }}>
      <TotalWinningsBanner amount={data?.totalWinnings ?? 0} />

      {items.map((item) => (
        <RapchikRewardCard
          key={item.id}
          theme={item.theme}
          title={item.title}
          dateLabel={item.dateLabel}
          rank={item.rank}
          leftVariant={item.leftVariant}
          leftLabel={item.leftLabel}
          leftValue={item.leftValue}
          prizeAmount={item.prizeAmount}
          prizeCurrency={item.prizeCurrency}
          showRevealPrize={item.showRevealPrize}
          onInfoClick={() => onInfoClick?.(item)}
          onRevealPrize={() => onRevealPrize?.(item)}
        />
      ))}
    </Box>
  );
}
